// Which row of THIS field a response record belongs to, for frontend surfaces
// that hold only one field's rows (charts, sankey) but receive records from a
// whole portfolio hierarchy.
//
// Three steps, in order of evidence:
//   1. RowID — the record answered a row of this field.
//   2. `_rowTitle` — the server's CURRENT title of the row the record answered
//      (fetchHierarchyData). Child organisations' records carry their own row
//      ids; they line up with this field's row by the text both rows read now.
//   3. RowTitle — the text at answer time. Only for records without the first
//      two (answers from before RowID existed, template data).
//
// Matching on RowTitle first stranded every answer to a reworded row
// (energiearmoede 0.9 → 0.10): the answer kept the old text, the row the new.
// AI-CONTEXT: See docs/pitfalls.md#database-rowtitle-join-strands-renamed-rows
// AI-CONTEXT: See docs/features/matrix-rowid-join.md

/**
 * @param {import('./matrixRowLookup').RowLookup|null|undefined} lookup - this field's rows
 * @param {{RowID?: string, RowTitle?: string, _rowTitle?: string|null}|null|undefined} record
 * @returns {import('./matrixRowLookup').RowDef|null}
 */
const resolveRecordRow = (lookup, record) => {
    if (!lookup || !record) return null
    if (record.RowID && lookup.byId[record.RowID]) return lookup.byId[record.RowID]
    if (record._rowTitle && lookup.byTitle[record._rowTitle]) return lookup.byTitle[record._rowTitle]
    if (record.RowTitle && lookup.byTitle[record.RowTitle]) return lookup.byTitle[record.RowTitle]
    return null
}

export default resolveRecordRow
